import { createApp } from 'vue'
import './style/index.less'
import App from './App.vue'
import '../utils/rem.js'
import { vLazy } from './directives/lazy'

createApp(App).directive('lazy', vLazy).mount('#app')
